import {
  DRBFMSession,
  DRBFMWizardStep,
  DRBFMInputData,
  DRBFMAnalysisProgress,
  SessionResultsResponse,
  DRBFMWorkflowResponse,
} from '../../types';

// ==============================================================================
// State Interface
// ==============================================================================

export interface DRBFMState {
  // Session management
  sessions: DRBFMSession[];
  currentSession: DRBFMSession | null;
  sessionsLoading: boolean;
  sessionsError: string | null;
  sessionsTotal: number;
  sessionsPage: number;
  sessionsPageSize: number;

  // Analysis state
  analysisProgress: DRBFMAnalysisProgress;
  analysisResults: SessionResultsResponse | null;

  // Staged workflow state
  workflow: DRBFMWorkflowResponse | null;
  workflowLoading: boolean;
  workflowError: string | null;

  // UI state
  wizardStep: DRBFMWizardStep;
  inputData: DRBFMInputData;

  // Export state
  isExporting: boolean;
  exportError: string | null;
}

// ==============================================================================
// Initial State
// ==============================================================================

export const initialInputData: DRBFMInputData = {
  itemName: '',
  title: '',
  oldSpecification: '',
  newSpecification: '',
  specOldDocumentId: undefined,
  specNewDocumentId: undefined,
  cadModelId: undefined,
  predefinedPartLabels: undefined,
};

export const initialAnalysisProgress: DRBFMAnalysisProgress = {
  isRunning: false,
  currentFlow: 0,
  overallProgress: 0,
  flowStatuses: {},
  messages: [],
  error: undefined,
};

export const initialState: DRBFMState = {
  // Session management
  sessions: [],
  currentSession: null,
  sessionsLoading: false,
  sessionsError: null,
  sessionsTotal: 0,
  sessionsPage: 1,
  sessionsPageSize: 20,

  // Analysis state
  analysisProgress: initialAnalysisProgress,
  analysisResults: null,

  // Staged workflow state
  workflow: null,
  workflowLoading: false,
  workflowError: null,

  // UI state
  wizardStep: 'input',
  inputData: initialInputData,

  // Export state
  isExporting: false,
  exportError: null,
};
